import { FC, useContext } from 'react';

import { useMutation } from '@apollo/client';
import { Button, H3, Modal } from '@smartshell/ui-kit';
import cn from 'classnames';

import { LocalizationContext } from 'localization';
import notification from 'services/notificationService';
import { SettingsContext } from 'settings';

import { USE_DEBT_MUTATION } from '../../schema';
import { IModalDebtProps } from './interfaces';
import s from './ModalDept.module.scss';

export const ModalDept: FC<IModalDebtProps> = ({ onClose }) => {
  const { t } = useContext(LocalizationContext);
  const {
    state: {
      settings: { countryCode },
    },
  } = useContext(SettingsContext);

  const [useDebt, { loading }] = useMutation(USE_DEBT_MUTATION, {
    fetchPolicy: 'no-cache',
    onCompleted: () => {
      notification.info({
        t,
        type: 'success',
        title: t('modalDebt.notification.success'),
      });
    },
    onError: () => {
      return notification.info({
        t,
        type: 'error',
        title: t('modalDebt.notification.error'),
      });
    },
  });

  return (
    <Modal className={s.modal} onClose={onClose}>
      <H3 className={s.title}>{t('permission.name.can_use_debt')}</H3>
      <p className={s.text}>{t('modalDebt.subtitle')}</p>
      <ul className={s.list}>
        <li className={s.item}>
          <span className={s.item_title}>{t('modalDebt.service.title')}</span>
          <span className={s.item_text}>
            {t(
              'modalDebt.service.subtitle',
              countryCode === 'KZ' ? '2 500 ₸' : '500 ₽'
            )}
          </span>
        </li>
        <li className={s.item}>
          <span className={s.item_title}>
            {t('modalDebt.subscription.title')}
          </span>
          <span className={s.item_text}>
            {t('modalDebt.subscription.subtitle')}
          </span>
        </li>
        <li className={s.item}>
          <span className={s.item_title}>{t('modalDebt.pay.title')}</span>
          <span className={s.item_text}>{t('modalDebt.pay.subtitle')}</span>
        </li>
      </ul>
      <Button
        onClick={() => {
          useDebt({ variables: { useDebt: true } }).finally(() => {
            onClose();
            window.location.reload();
          });
        }}
        fullWidth
        className={s.button}
        variant="primary"
        isLoading={loading}
      >
        {t('modalDebt.button')}
      </Button>
      <span className={cn(s.button, s.button_link)}>
        {t('modalDebt.conditions')}
      </span>
    </Modal>
  );
};
